<script>
export default {
    components: {
        UiAlert: () => import(/* webpackChunkName: "chunk-ui-alert" */ './ui/ui-alert.vue'),
    }
};

</script>
